module.exports = __webpack_public_path__ + "static/98-1a75c15dcebeeca7ec48665e9ae4011e.jpg";